module.exports = __webpack_public_path__ + "img/product-7-mobileguanhuai.304d8f34.png";